import script from "./NavigatorComponent.vue?vue&type=script&setup=true&lang=ts"
export * from "./NavigatorComponent.vue?vue&type=script&setup=true&lang=ts"

import "./NavigatorComponent.vue?vue&type=style&index=0&id=6272a2a1&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6272a2a1"]])

export default __exports__